import React from 'react';
import PropTypes from 'prop-types';

// data imports
import { draggableClass } from 'logic/data/Izenda.ReportPartKPIConstants.js';

const KPIImageContainer = (props) => {
    const {
        isPreview,
        src,
        properties
    } = props;

    const previewBackgroundClass = isPreview ? 'kpi-image__container--previewBackground' : '';
   
    return (
        <div className={`kpi-image__container ${draggableClass} ${previewBackgroundClass}`} style={ properties.getStyle()}>
            {
                src ?
                <img
                    className='kpi-image__src'
                    src={src}
                /> :
                <div className='kpi-image__preview'>
                    <span className='icon-img'></span>
                </div>
            }
        </div>
    );
};

KPIImageContainer.propTypes = {
    isPreview: PropTypes.bool,
    src: PropTypes.string
};

export default KPIImageContainer;



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartKPI/Izenda.KPIImageContainer.jsx